import { axios } from '@/lib/axios';

export const addCorporateAddress = async (id: number, data: any) => {
    const { success, message } = await axios.post(`v1/add-corporation-address/${id}`, data);

    return { success, message };
};
